import React from "react";
import CheckoutCard from "./CheckoutCard";
import { useDirectCheckout } from "../hooks/useDirectCheckout";

type Props = {
  open: boolean;
  amount: number;
  merchantName: string;
  onClose: () => void;
};

const CheckoutModal: React.FC<Props> = ({
  open,
  amount,
  merchantName,
  onClose,
}) => {
  const { loading, error, qrDataUrl, appLaunchUrl, timeRemaining, viewState, refresh } =
    useDirectCheckout({
      open,
      amount,
    });

  if (!open) return null;

  const amountLabel = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "EUR",
  }).format(amount);

  const mins = Math.floor(timeRemaining / 60);
  const secs = timeRemaining % 60;
  const timeLabel = `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;

  return (
    <div className="ep-checkoutOverlay">
      <div className="ep-modalWrap">
        {loading && (
          <div className="ep-loadingCard">
            <div className="ep-spinner" />
            <p>Creating payment intent...</p>
          </div>
        )}
        {!loading && error && (
          <div className="ep-loadingCard ep-loadingCard--error">
            <p>{error}</p>
            <button className="ep-retryBtn" onClick={refresh}>
              Retry
            </button>
            <button className="ep-retryBtn ep-retryBtn--ghost" onClick={onClose}>
              Close
            </button>
          </div>
        )}
        {!loading && !error && (
          <>
            <p className="ep-modalMerchant">{merchantName}</p>
            <CheckoutCard
              state={viewState}
              amountLabel={amountLabel}
              timeLabel={timeLabel}
              qrDataUrl={qrDataUrl}
              appLaunchUrl={appLaunchUrl}
              onClose={onClose}
              onRefreshQr={refresh}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default CheckoutModal;
